import { useState } from 'react';

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  };

  return (
    <section className="py-16 md:py-20 bg-secondary-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 flex items-center justify-center mx-auto mb-6 rounded-full bg-primary-100/70 text-primary-600">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          订阅我们的每周灵感
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-md mx-auto">
          每周一封温暖的邮件送到你的信箱，包含婚姻经营技巧、生活智慧和女性成长内容。
        </p>

        {submitted ? (
          <div className="py-3 px-6 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium inline-flex items-center gap-2">
            <i className="ri-check-line"></i>
            订阅成功！欢迎加入我们的温暖大家庭。
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <div className="hp-field-wrapper">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-5 py-3 rounded-full border border-background-300/60 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
            />
            <button
              type="submit"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              免费订阅
            </button>
          </form>
        )}
      </div>
    </section>
  );
}